
/*!
 * pixelzoom v0.0.1
 * (c) 2018 Pixel Union
 */

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var Pixelzoom = function () {
  function Pixelzoom(container, options) {
    classCallCheck(this, Pixelzoom);

    this.options = _extends({
      imageClass: 'pixelzoom--image',
      imageSource: options.imageSource || container.querySelector('img').src,
      initialZoom: 1,
      dragPan: false,
      naturalPan: false,
      maxZoom: 9999,
      zoomSensitivity: 1,
      zoomSteps: 1,
      overflowContainer: null
    }, options);

    // Overflow container
    this.overflowContainer = this.options.overflowContainer;

    // Image container
    this.container = container;
    this.container.style.cursor = this.options.maxZoom > this.options.initialZoom ? 'zoom-in' : 'zoom-out';
    this.containerWidth = null;
    this.containerHeight = null;

    // Image
    this.image = new Image();
    this.imageSrc = this.options.imageSource;
    this.imageWidth = null;
    this.imageHeight = null;

    // State
    this.x = 0;
    this.y = 0;
    this.lastX = 0;
    this.lastY = 0;
    this.dragX = null;
    this.dragY = null;
    this.lastDragX = null;
    this.lastDragY = null;
    this.zoom = Math.min(this.options.maxZoom, this.options.initialZoom);
    this.zoomMax = this.options.maxZoom;
    this.zoomMin = 1;
    this.zoomSensitivity = this.options.zoomSensitivity;
    this.zoomSteps = Math.min(this.options.maxZoom, this.options.zoomSteps);
    this.distance = 0;
    this.cursor = this.container.style.cursor;
    this.panning = false;
    this.mouseDown = false;
    this.dragging = false;
    this.touched = false;

    this._triggerEvent('loading');
    this._loadImage();
  }

  /**
    * Load image
    *
    * @private
    */


  createClass(Pixelzoom, [{
    key: '_loadImage',
    value: function _loadImage() {
      var _this = this;

      this.image.addEventListener('load', function () {
        _this._appendImage();
      });

      this.image.classList.add(this.options.imageClass);
      this.image.src = this.imageSrc;

      this.image.style.position = 'absolute';
      this.image.style.top = '100%';
      this.image.style.left = '100%';
      this.image.style.maxWidth = '100%';
      this.image.style.maxHeight = '100%';
      this.image.style.transformOrigin = 'top left';
    }

    /**
      * Append image to the DOM
      *
      * @private
      */

  }, {
    key: '_appendImage',
    value: function _appendImage() {
      this._triggerEvent('loaded');
      this.container.appendChild(this.image);

      this.refresh();
      this._bindEvents();

      if (this.zoom > this.zoomMin) {
        this.x = -(this.imageWidth * this.zoom) + (this.imageWidth * this.zoom - this.imageWidth) / 2;
        this.y = -(this.imageHeight * this.zoom) + (this.imageHeight * this.zoom - this.imageHeight) / 2;

        if (this.lastDragX === null && this.lastDragY == null) {
          var offset = this.container.getBoundingClientRect();
          var dragX = this.overflowContainer && this.overflowContainer.offsetWidth >= this.imageWidth * this.zoom ? this.overflowContainer.offsetWidth : this.containerWidth;
          var dragY = this.overflowContainer && this.overflowContainer.offsetWidth >= this.imageHeight * this.zoom ? this.overflowContainer.offsetHeight : this.containerHeight;

          var scrollLeft = window.pageXOffset ? window.pageXOffset : document.body.scrollLeft;
          var scrollTop = window.pageYOffset ? window.pageYOffset : document.body.scrollTop;

          this.lastDragX = dragX / 2 + offset.left + scrollLeft;
          this.lastDragY = dragY / 2 + offset.top + scrollTop;
        }
      } else {
        this.x = -this.imageWidth;
        this.y = -this.imageHeight;
      }

      this.lastX = this.x;
      this.lastY = this.y;

      this._update();
    }

    /**
      * Bind mouse and touch events
      *
      * @private
      */

  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      var _this2 = this;

      this.container.addEventListener('mousedown', function (event) {
        event.stopPropagation();

        var pointer = _this2._getPointerBounds(event);

        _this2._initializeDrag(pointer[0]);
      });

      this.container.addEventListener('mouseenter', function () {
        event.stopPropagation();

        _this2._initializeMouse();
      });

      this.container.addEventListener('touchstart', function (event) {
        event.stopPropagation();

        var pointers = _this2._getPointerBounds(event);

        _this2._initializeTouch(pointers[0], pointers[1]);
      });

      this.container.addEventListener('dragstart', function (event) {
        event.stopPropagation();

        _this2._preventDrag(event);
      });

      ['mousemove', 'touchmove'].forEach(function (eventType) {
        _this2.container.addEventListener(eventType, function (event) {
          var pointers = _this2._getPointerBounds(event);

          _this2._pan(eventType, pointers[0], pointers[1]);
        });
      });

      this.container.addEventListener('mouseup', function (event) {
        event.stopPropagation();

        _this2._tap({
          x: event.pageX,
          y: event.pageY
        });
      });

      ['mouseleave', 'touchend'].forEach(function (eventType) {
        _this2.container.addEventListener(eventType, function (event) {
          event.stopPropagation();

          _this2._release();
        });
      });

      this.container.addEventListener('wheel', function (event) {
        event.stopPropagation();

        _this2._scroll(event.deltaY, {
          x: event.pageX,
          y: event.pageY
        });
      });

      document.body.addEventListener('touchmove', function (event) {
        _this2._preventScroll(event);
      });
    }

    /**
      * Increment or decrement zoom
      *
      * @param {number} adjustment
      * @private
      */

  }, {
    key: '_setZoom',
    value: function _setZoom(adjustment) {
      this._triggerEvent('zoom');

      var zoom = this.zoom + adjustment;

      zoom = Math.min(this.zoomMax, zoom);
      zoom = Math.max(this.zoomMin, zoom);
      this.zoom = zoom;

      if (this.zoom === this.zoomMax) {
        this.container.style.cursor = 'zoom-out';
        this.cursor = 'zoom-out';

        this._triggerEvent('zoomMax');
      } else {
        this.container.style.cursor = 'zoom-in';
        this.cursor = 'zoom-in';
      }

      if (this.zoom === this.zoomMin) {
        this.lastDragX = null;
        this.lastDragY = null;

        this._triggerEvent('zoomMin');
      }
    }

    /**
      * Set image center position
      *
      * @param {object} pointer
      * @private
      */

  }, {
    key: '_setCenter',
    value: function _setCenter(pointer, event) {
      if (this.zoom !== this.zoomMin) {
        var offset = this.container.getBoundingClientRect();
        var zoomWidth = this.imageWidth * this.zoom - this.containerWidth;
        var zoomHeight = this.imageHeight * this.zoom - this.containerHeight;

        var scrollLeft = window.pageXOffset ? window.pageXOffset : document.body.scrollLeft;
        var scrollTop = window.pageYOffset ? window.pageYOffset : document.body.scrollTop;

        if (!(this.zoom - 1 > this.zoomMin && event === 'tap') || event === 'tap' && this.zoomSteps >= this.zoomMax) {
          this.lastX = pointer.x;
          this.lastY = pointer.y;
        }

        var currentX = (offset.left - this.lastX) * (zoomWidth / this.containerWidth) - this.containerWidth + scrollLeft * this.zoom - scrollLeft;
        var currentY = (offset.top - this.lastY) * (zoomHeight / this.containerHeight) - this.containerHeight + scrollTop * this.zoom - scrollTop;

        currentX = Math.max(-this.imageWidth * this.zoom, currentX);
        currentY = Math.max(-this.imageHeight * this.zoom, currentY);

        if (this.overflowContainer) {
          currentX = Math.max(-this.imageWidth * this.zoom + offset.left, currentX);
          currentY = Math.max(-this.imageHeight * this.zoom + offset.top, currentY);

          currentX = Math.min(-this.imageWidth - offset.left, currentX);
          currentY = Math.min(-this.imageHeight - offset.top, currentY);
        }

        if (this.overflowContainer && this.overflowContainer.offsetWidth >= this.imageWidth * this.zoom) {
          this.x = -(this.imageWidth * this.zoom) + (this.imageWidth * this.zoom - this.imageWidth) / 2;
        } else {
          this.x = Math.min(-this.imageWidth, currentX);
        }

        if (this.overflowContainer && this.overflowContainer.offsetHeight >= this.imageHeight * this.zoom) {
          this.y = -(this.imageHeight * this.zoom) + (this.imageHeight * this.zoom - this.imageHeight) / 2;
        } else {
          this.y = Math.min(-this.imageHeight, currentY);
        }
      } else {
        this.x = -this.imageWidth;
        this.y = -this.imageHeight;
        this.lastX = 0;
        this.lastY = 0;
        this.lastDragX = null;
        this.lastDragY = null;
      }
    }

    /**
      * Initialize zoom for non-touch devices
      *
      * @private
      */

  }, {
    key: '_initializeMouse',
    value: function _initializeMouse() {
      this._triggerEvent('touch');
      this.refresh();
    }

    /**
      * Initialize drag
      *
      * @private
      */

  }, {
    key: '_initializeDrag',
    value: function _initializeDrag(pointer) {
      if (this.options.dragPan) {
        this.mouseDown = true;

        if (this.lastDragX === null && this.lastDragY === null) {
          this.lastDragX = pointer.x;
          this.lastDragY = pointer.y;
        }
      }
    }

    /**
      * Initialize zoom for touch devices
      *
      * @param {object} touches
      * @param {object} pointerOne
      * @param {object} pointerTwo
      * @private
      */

  }, {
    key: '_initializeTouch',
    value: function _initializeTouch(pointerOne, pointerTwo) {
      this._triggerEvent('touch');

      this.touched = true;

      if (this.lastDragX === null && this.lastDragY == null) {
        this.lastDragX = pointerOne.x;
        this.lastDragY = pointerOne.y;
      }

      if (pointerTwo && pointerTwo.x && pointerTwo.y) {
        this.distance = Math.hypot(pointerOne.x - pointerTwo.x, pointerOne.y - pointerTwo.y);
      }
    }

    /**
      * Pan image
      *
      * @param {string} eventType
      * @param {object} touches
      * @param {object} pointerOne
      * @param {object} pointerTwo
      * @private
      */

  }, {
    key: '_pan',
    value: function _pan(eventType, pointerOne, pointerTwo) {
      if (pointerTwo && pointerTwo.x && pointerTwo.y) {
        if (this.panning || !this.touched) {
          this._pinch({
            x: pointerOne.x,
            y: pointerOne.y
          }, {
            x: pointerTwo.x,
            y: pointerTwo.y
          });
        }
      } else {
        if (this.options.dragPan && this.mouseDown === false && eventType !== 'touchmove') {
          return;
        } else if (this.options.dragPan && this.mouseDown || eventType === 'touchmove') {
          this.dragging = true;
          this.container.style.cursor = 'move';
        }

        if (this.panning || !this.touched) {
          if (this.dragging) {
            this._drag({
              x: pointerOne.x,
              y: pointerOne.y
            });
          } else {
            this._setCenter({
              x: pointerOne.x,
              y: pointerOne.y
            });

            this._update();
          }
        } else {
          if (!this.dragging) {
            this._setCenter({
              x: this.lastX,
              y: this.lastY
            });

            this._update();
          }
        }
      }

      if (eventType === 'touchmove' && !this.panning) {
        this.panning = true;
        this._triggerEvent('pan');
      }
    }

    /**
      * Zoom into the image on pinch
      *
      * @param {object} touchOne
      * @param {object} touchTwo
      * @private
      */

  }, {
    key: '_pinch',
    value: function _pinch(touchOne, touchTwo) {
      this._triggerEvent('pinch');

      var distance = Math.hypot(touchOne.x - touchTwo.x, touchOne.y - touchTwo.y);

      var zoomAdjustment = this.zoom / (this.zoomSensitivity * 2);
      var difference = Math.abs(distance) - Math.abs(this.distance);

      if (difference > 0.5 || difference < -0.5) {
        this._setZoom(distance > this.distance ? +zoomAdjustment : -zoomAdjustment);
      }

      this.refresh();

      if (this.zoom < this.zoomMax) {
        if (distance > this.distance) {
          touchOne.x -= (touchOne.x - touchTwo.x) / 2;
          touchOne.y -= (touchOne.y - touchTwo.y) / 2;
        } else {
          touchOne.x = this.lastDragX;
          touchOne.y = this.lastDragY;
        }

        this.lastDragX = touchOne.x;
        this.lastDragY = touchOne.y;
        this.dragX = 0;
        this.dragY = 0;

        this._setCenter({
          x: touchOne.x,
          y: touchOne.y
        });

        this.distance = distance;

        this._update();
      }
    }

    /**
      * Drag image
      *
      * @param {object} pointer
      * @private
      */

  }, {
    key: '_drag',
    value: function _drag(pointer) {
      if (this.dragX && this.dragY && this.lastDragX !== null && this.lastDragY !== null) {
        var differenceX = (this.dragX - pointer.x) / (this.zoom / 2);
        var differenceY = (this.dragY - pointer.y) / (this.zoom / 2);
        var dragX = this.lastDragX;
        var dragY = this.lastDragY;

        if (this.options.naturalPan) {
          dragX += differenceX;
          dragY += differenceY;
        } else {
          dragX -= differenceX;
          dragY -= differenceY;
        }

        dragX = Math.min(this.imageWidth * this.zoom, dragX);
        this.lastDragX = Math.max(0, dragX);

        dragY = Math.min(this.imageHeight * this.zoom, dragY);
        this.lastDragY = Math.max(0, dragY);

        this.lastX = this.lastDragX;
        this.lastY = this.lastDragY;

        this._setCenter({
          x: this.lastDragX,
          y: this.lastDragY
        });

        this._update();
      }

      this.dragX = pointer.x;
      this.dragY = pointer.y;
    }

    /**
      * Zoom into the image on tap/click
      *
      * @param {object} pointer
      * @private
      */

  }, {
    key: '_tap',
    value: function _tap(pointer) {
      this._triggerEvent('tap');

      if (!this.panning && !this.dragging) {
        this._setZoom(this.zoomMax > this.zoom ? +this.zoomSteps : -this.zoomMax);

        this.refresh();

        this._setCenter(pointer, 'tap');

        this.lastDragX = this.lastX;
        this.lastDragY = this.lastY;

        this._update();
      }

      this.panning = false;
      this.mouseDown = false;
      this.dragging = false;
      this.touched = false;
      this.distance = 0;
      this.dragX = 0;
      this.dragY = 0;

      this.container.style.cursor = this.cursor;
    }

    /**
      * Zoom into the image on scroll
      *
      * @param {int} scale
      * @param {object} pointer
      * @private
      */

  }, {
    key: '_scroll',
    value: function _scroll(scale, pointer) {
      if (!this.dragging) {
        this._triggerEvent('scroll');

        var zoomAdjustment = this.zoom / this.zoomSensitivity;

        if (this.options.dragPan && this.zoom > this.zoomMin) {
          pointer.x = this.lastDragX;
          pointer.y = this.lastDragY;
        }

        this.lastDragX = pointer.x;
        this.lastDragY = pointer.y;
        this.dragX = 0;
        this.dragY = 0;

        this._setZoom(scale < 0 ? +zoomAdjustment : -zoomAdjustment);

        this.refresh();

        this._setCenter(pointer);
        this._update();
      }
    }

    /**
      * Set panning to false
      *
      * @private
      */

  }, {
    key: '_release',
    value: function _release() {
      this._triggerEvent('release');
      this.panning = false;
      this.mouseDown = false;
      this.dragging = false;
      this.dragX = 0;
      this.dragY = 0;

      this.container.style.cursor = this.cursor;
    }

    /**
      * Prevent images from being dragged
      *
      * @param {object} event
      * @private
      */

  }, {
    key: '_preventDrag',
    value: function _preventDrag(event) {
      event.preventDefault();
    }

    /**
      * Prevent body from scrolling when image is being panned
      *
      * @param {object} event
      * @private
      */

  }, {
    key: '_preventScroll',
    value: function _preventScroll(event) {
      if (this.panning) {
        event.preventDefault();
      }
    }

    /**
      * Get the pointer bounds from the event
      *
      * @param {object} event
      * @private
      */

  }, {
    key: '_getPointerBounds',
    value: function _getPointerBounds(event) {
      var pointers = [{
        x: event.pageX ? event.pageX : event.touches[0].clientX,
        y: event.pageY ? event.pageY : event.touches[0].clientY
      }, {
        x: event.targetTouches && event.targetTouches.length > 1 ? event.touches[1].clientX : null,
        y: event.targetTouches && event.targetTouches.length > 1 ? event.touches[1].clientY : null
      }];

      return pointers;
    }

    /**
      * Create an event and trigger it
      *
      * @param {string} name
      * @private
      */

  }, {
    key: '_triggerEvent',
    value: function _triggerEvent(name) {
      var event = new Event('pixelzoom:' + name, { 'bubbles': true, 'cancelable': false });
      this.container.dispatchEvent(event);
    }

    /**
      * Update the image position by adjustng the CSS
      *
      * @private
      */

  }, {
    key: '_update',
    value: function _update() {
      var _this3 = this;

      requestAnimationFrame(function () {
        _this3.image.style.transform = 'translate(' + _this3.x + 'px, ' + _this3.y + 'px) scale(' + _this3.zoom + ')';
      });
    }

    /**
      * Refresh variables
      *
      * @public
      */

  }, {
    key: 'refresh',
    value: function refresh() {
      this.containerWidth = this.container.offsetWidth;
      this.containerHeight = this.container.offsetHeight;
      this.imageWidth = Math.min(this.containerWidth, this.image.width);
      this.imageHeight = Math.min(this.containerHeight, this.image.height);

      var maxZoom = Math.floor(this.image.naturalWidth / this.containerWidth);
      this.zoomMax = this.options.maxZoom < maxZoom ? this.options.maxZoom : maxZoom;
      this.zoom = Math.min(this.zoomMax, this.zoom);
      this.zoomSteps = Math.min(this.zoomMax, this.zoomSteps);

      if (this.zoomMax <= 1) {
        this.container.style.cursor = 'default';
        this.cursor = 'default';
      }
    }

    /**
      * Update the image position by adjustng the CSS
      *
      * @public
      */

  }, {
    key: 'unload',
    value: function unload() {
      var _this4 = this;

      this.image.removeEventListener('load', this._appendImage);
      document.body.removeEventListener('touchmove', this._preventScroll);

      [['mouseenter', this._initializeMouse], ['touchstart', this._initializeTouch], ['mousedown', this._initializeDrag], ['dragstart', this._preventDrag], ['mousemove', this._pan], ['touchmove', this._pan], ['mouseup', this._tap], ['touchend', this._release], ['mouseleave', this._release], ['wheel', this._scroll]].forEach(function (eventType) {
        _this4.container.removeEventListener(eventType[0], eventType[1]);
      });

      this.image.parentNode.removeChild(this.image);
    }
  }]);
  return Pixelzoom;
}();

export default Pixelzoom;
